import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633a60b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notifications-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ibf-h2 notifications-title" }, "Notifications")
], -1))
const _hoisted_3 = { class: "notifications-content" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "message-notifictaions-item-text" }
const _hoisted_6 = { class: "gordita-regular-14 brand_almost_black message-item-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "notifications-date gordita-400-11" }
const _hoisted_9 = {
  key: 0,
  class: "bottom-border"
}

import { useMessageNotificationsQuery } from '@/graphql/codegen/generated/graphql';
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { dateUtils } from '@/services/dateUtils';
import moment from 'moment';
import { notificationConfigByType, mapUserNotificationsTypeByKey, userNotificationTypeMap } from './const.windows';


export default /*#__PURE__*/_defineComponent({
  __name: 'messagesContent.windows',
  setup(__props) {

const { t } = useI18n();
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_userNotificationsQuery = useMessageNotificationsQuery(
  () => ({
    coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
  }),
  { fetchPolicy: 'no-cache' },
);
const notifications = computed(() => GQL_userNotificationsQuery?.result?.value?.ibManagerEntities?.notifications || []);
const getTextDataById = (notificationType: keyof typeof mapUserNotificationsTypeByKey) => {
  const content = t(`generic.userNotifications.${notificationType}.content`);
  const title = t(`generic.userNotifications.${notificationType}.title`);
  const type = mapUserNotificationsTypeByKey[notificationType];
  return {
    type,
    title,
    content,
  };
};

const getNotificationsTitle = (notificationType: keyof typeof mapUserNotificationsTypeByKey) => {
  const data = getTextDataById(notificationType);
  return Object.prototype.hasOwnProperty.call(data, 'title') ? data.title : '';
};
const replaceNotificationDataPlaceholder = (content: string, dataToReplace?: string) => content.replace('{0}', dataToReplace || '');
const getNotificationsContent = (notificationType: keyof typeof mapUserNotificationsTypeByKey, notificationData: string | null | undefined) => {
  if ((notificationData?.length || 0) > 0) {
    let content = t(`generic.userNotifications.${notificationType}.content`);
    content = replaceNotificationDataPlaceholder(
      content,
      (notificationType === userNotificationTypeMap.licenseAboutToBeExpired && notificationData
        ? moment(+notificationData)
            .subtract(1, 'days')
            .format('MMM D')
        : notificationData) || '',
    );
    return content.length > 0 ? content : '';
  }
  const data = getTextDataById(notificationType);
  return Object.prototype.hasOwnProperty.call(data, 'content') ? data.content : '';
};
const getNotificationsIcon = (notificationType: keyof typeof mapUserNotificationsTypeByKey) => {
  const data = getTextDataById(notificationType);
  return data.type && notificationConfigByType[data.type as keyof typeof notificationConfigByType] ? notificationConfigByType[data.type as keyof typeof notificationConfigByType].icon : '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).slice().reverse(), (item, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["message-notifictaions-icon", getNotificationsIcon(item?.notificationType as any || 0)])
            }, null, 2),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(getNotificationsTitle((item?.notificationType as any) || 0)), 1),
              _createElementVNode("div", {
                class: "gordita-400-12 message-item-description",
                innerHTML: getNotificationsContent(item?.notificationType as any || 0, item?.data)
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(dateUtils).getNotificationsUserFriendlyDate(item?.createdAt)), 1),
          (i < _unref(notifications).length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})